import {
  useComparison,
  type ComparisonResult,
  type ComparisonSpec
} from "./useComparison";
import type { CompareToSelection, ContractComparison } from "./types";

export interface UseContractsComparisonReturn
  extends ComparisonResult<ContractComparison> {}

// Module-level so its identity is stable — `useComparison` keys memos on it.
const CONTRACTS_SPEC: ComparisonSpec<ContractComparison> = {
  endpoint: "contracts/compare",
  idsField: "contractIds",
  rowsField: "contracts",
  readRowId: (row) => row.contractId
  // No `notFoundField`: this endpoint drops ids it cannot resolve rather than
  // reporting them, so `notFoundIds` is always empty here. The company-grain
  // endpoint reports them, which is why the field is optional rather than
  // required.
};

/** Per-contract movement for the rows currently on screen. */
export const useContractsComparison = (
  contractIds: readonly string[],
  selection: CompareToSelection | undefined,
  enabled: boolean = true
): UseContractsComparisonReturn =>
  useComparison(contractIds, selection, enabled, CONTRACTS_SPEC);
